module.exports = __webpack_public_path__ + "assets/img/open1.ae3ff174.svg";